import { executeRequest, Request } from '@jfs/network'
import { Platform } from 'react-native'
import { Config } from 'react-native-config'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  if (response?.status === 'SUCCESS' && response?.data?.payoutConfig) {
    return response?.data?.payoutConfig?.autoSettle === false
  }
  return false
}

let CHANNEL_ID = ''

if (Platform.OS === 'android' || Platform.OS === 'ios') {
  CHANNEL_ID = Config.REACT_APP_CHANNEL_ID ?? ''
} else {
  CHANNEL_ID = window?._env_?.REACT_APP_CHANNEL_ID ?? ''
}

const getSplitPayemntEnabledForMid = (mid: any, tokens: any, userAccessToken: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.getSplitSettlementEnabled,
    method: 'POST',
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: {
      entity: {
        initiatingEntityId: CHANNEL_ID,
        entityId: mid,
      },
    },
    cache: false,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getSplitPayemntEnabledForMid }
